import React from 'react';
import cn from 'classnames';

import { ISpinnerProps } from './Spinner.types';

import { getSpinnerStyles, spinnerColors, spinners } from './constants';

import innerPart from '@assets/logoInner.svg';
import outerPart from '@assets/logoOuter.svg';

import styles from './Spinner.module.scss';

const Spinner: React.FC<ISpinnerProps> = ({
	size = 32,
	spinnerId = 0,
	spinnerColorId = spinnerColors[0].id,
}: ISpinnerProps) => {
	const spinnerColor = spinnerColors.find(spinnerColor => spinnerColor.id === spinnerColorId)?.color;

	const spinnerStyle = getSpinnerStyles(size, spinnerColor || spinnerColors[0].color);

	const isSpinnerExist = spinners.some(spinner => spinner.id === spinnerId);

	const spinner = spinners.find(spinner => spinner.id === spinnerId);

	const spinnerClassName = cn([styles[spinner?.className || 'spinner0']]);

	return (
		spinnerId === 0 || !isSpinnerExist
			? <div
				className={styles.f5gSpinnerContainer}
				data-testid='loading-spinner'
			>
				<img
					alt='Logo'
					className={styles.f5gSpinnerOuterPart}
					src={outerPart}
					width={size}
				/>
				<img
					alt='Logo'
					className={styles.f5gInnerPart}
					src={innerPart}
					width={size}
				/>
			</div>
			: <div
				className={spinnerClassName}
				style={spinnerStyle}
			/>
	);
};

export default Spinner;
